<template>
  <div v-if="scored">
    <div v-if="firstSections.length > 0" class="sections-container">
      <h3>Ⅰ 目标声母在不同目标词里的训练情况：</h3>
      <div class="section" v-for="item in firstSections" :key="item.letter">
        <p class="word-text">【{{ item.letter }}】 {{ item.pinyin }}</p>
        <p class="ac-text" v-for="ac in item.accuracys" :key="ac.title">
          {{ ac.title }} = {{ ac.ratio ? ac.ratio.toFixed(0) : 0 }} %
        </p>
      </div>
    </div>

    <div v-if="secondSections.length > 0" class="sections-container">
      <h3>Ⅱ 每个目标声母整体的训练情况：</h3>
      <div class="section" v-for="item in secondSections" :key="item.letter">
        <p class="word-text">【{{ item.letter }}】 {{ item.pinyin }}</p>
        <p class="ac-text" v-for="ac in item.accuracys" :key="ac.title">
          {{ ac.title }} = {{ ac.ratio ? ac.ratio.toFixed(0) : 0 }} %
        </p>
      </div>
    </div>

    <div class="sections-container">
      <h3>Ⅲ 整节课的训练情况：</h3>
      <div class="section" v-for="item in thirdSections" :key="item.letter">
        <p v-if="item.letter" class="word-text">
          【{{ item.letter }}】 {{ item.pinyin }}
        </p>
        <p class="ac-text" v-for="ac in item.accuracys" :key="ac.title">
          {{ ac.title }} = {{ ac.ratio.toFixed(0) }} %
        </p>
      </div>
    </div>
  </div>
  <div v-else>
    <h1>今日表现</h1>
    <div v-for="m in manifestations" :key="m.key" class="select-row">
      <label>{{ m.title }}</label>
      <select v-model="m.score">
        <option value="良好">良好</option>
        <option value="普通">普通</option>
        <option value="不佳">不佳</option>
      </select>
    </div>

    <loading :active.sync="loading" :height="40" :width="40"></loading>

    <button @click="_updateTest" class="submit-button">提交</button>
  </div>
</template>

<script>
import { pinyin } from 'pinyin-pro';
import { portalUrl } from '../static/config';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

const _0orL = (r) => {
  if (r !== undefined && r !== null) {
    return r.length;
  }

  return 0;
};

export default {
  name: 'SwamReport',
  data() {
    return {
      firstSections: [],
      secondSections: [],
      thirdSections: [],
      scored: false,
      loading: false,
      manifestations: [
        {
          title: '警醒度',
          key: 'vigilance',
          score: '良好',
        },
        {
          title: '配合度',
          key: 'blendage',
          score: '良好',
        },
        {
          title: '注意力',
          key: 'attention',
          score: '良好',
        },
        {
          title: '情绪',
          key: 'emotions',
          score: '良好',
        },
        {
          title: '主动性',
          key: 'initiative',
          score: '良好',
        },
        {
          title: '互动性',
          key: 'initiative_loop',
          score: '良好',
        },
      ],
    };
  },

  components: {
    Loading,
  },

  computed: {},

  mounted() {
    const flows = this.$route.query.flows;

    const firstSections = flows.map((f) => {
      const hasNo =
        f.actions.findIndex((a) => a.action_name === 'no-thumb') >= 0;

      const result = Object.groupBy(
        f.actions,
        ({ action_name }) => action_name
      );
      let accuracys;
      if (hasNo) {
        accuracys = [
          {
            title: '总正确率',
            ratio:
              ((_0orL(result['big-thumb']) + _0orL(result['small-thumb'])) /
                (_0orL(result['big-thumb']) +
                  _0orL(result['small-thumb']) +
                  _0orL(result['no-thumb']))) *
              100,
          },
          {
            title: '自主发音正确率',
            ratio:
              (_0orL(result['big-thumb']) /
                (_0orL(result['big-thumb']) +
                  _0orL(result['small-thumb']) +
                  _0orL(result['no-thumb']))) *
              100,
          },
          {
            title: '提示后发音正确率',
            ratio:
              (_0orL(result['small-thumb']) /
                (_0orL(result['big-thumb']) +
                  _0orL(result['small-thumb']) +
                  _0orL(result['no-thumb']))) *
              100,
          },
        ];
      } else {
        accuracys = [
          {
            title: '正确率',
            ratio:
              (_0orL(result['big-thumb']) /
                (_0orL(result['big-thumb']) + _0orL(result['small-thumb']))) *
              100,
          },
        ];
      }

      return {
        letter: f.initial,
        pinyin: pinyin(f.word),
        accuracys,
      };
    });

    this.firstSections = firstSections || [];

    const mergedSections = [];

    flows.forEach((f) => {
      const hasF = mergedSections.findIndex((m) => m.letter === f.initial);

      if (hasF >= 0) {
        const exitedOne = mergedSections[hasF];

        exitedOne.actions = [...exitedOne.actions, ...f.actions];

        mergedSections[hasF] = exitedOne;
      } else {
        mergedSections.push({
          letter: f.initial,
          actions: f.actions,
        });
      }
    });

    const secondSections = mergedSections.map((m) => {
      const result = Object.groupBy(
        m.actions,
        ({ action_name }) => action_name
      );

      const hasNo = result['no-thumb'] && result['no-thumb'].length > 0;

      let accuracys;
      if (hasNo) {
        accuracys = [
          {
            title: '总正确率',
            ratio:
              ((_0orL(result['big-thumb']) + _0orL(result['small-thumb'])) /
                (_0orL(result['big-thumb']) +
                  _0orL(result['small-thumb']) +
                  _0orL(result['no-thumb']))) *
              100,
          },
          {
            title: '自主发音正确率',
            ratio:
              (_0orL(result['big-thumb']) /
                (_0orL(result['big-thumb']) +
                  _0orL(result['small-thumb']) +
                  _0orL(result['no-thumb']))) *
              100,
          },
          {
            title: '提示后发音正确率',
            ratio:
              (_0orL(result['small-thumb']) /
                (_0orL(result['big-thumb']) +
                  _0orL(result['small-thumb']) +
                  _0orL(result['no-thumb']))) *
              100,
          },
        ];
      } else {
        accuracys = [
          {
            title: '正确率',
            ratio:
              (_0orL(result['big-thumb']) /
                (_0orL(result['big-thumb']) + _0orL(['small-thumb']))) *
              100,
          },
        ];
      }

      return {
        letter: m.letter,
        accuracys,
      };
    });

    this.secondSections = secondSections || [];

    let allActions = [];

    flows.forEach((f) => {
      allActions = [...allActions, ...f.actions];
    });

    const result = Object.groupBy(allActions, ({ action_name }) => action_name);

    const hasNo = result['no-thumb'] && result['no-thumb'].length;

    let accuracys;
    if (hasNo) {
      accuracys = [
        {
          title: '总正确率',
          ratio:
            ((_0orL(result['big-thumb']) + _0orL(result['small-thumb'])) /
              (_0orL(result['big-thumb']) +
                _0orL(result['small-thumb']) +
                _0orL(result['no-thumb']))) *
            100,
        },
        {
          title: '自主发音正确率',
          ratio:
            (_0orL(result['big-thumb']) /
              (_0orL(result['big-thumb']) +
                _0orL(result['small-thumb']) +
                _0orL(result['no-thumb']))) *
            100,
        },
        {
          title: '提示后发音正确率',
          ratio:
            (_0orL(result['small-thumb']) /
              (_0orL(result['big-thumb']) +
                _0orL(result['small-thumb']) +
                _0orL(result['no-thumb']))) *
            100,
        },
      ];
    } else {
      accuracys = [
        {
          title: '正确率',
          ratio:
            (_0orL(result['big-thumb']) /
              (_0orL(result['big-thumb']) + _0orL(result['small-thumb']))) *
            100,
        },
      ];
    }

    this.thirdSections = [{ accuracys }];
  },

  methods: {
    _updateTest() {
      this.loading = true;

      const manifestation = {};

      this.manifestations.forEach((m) => {
        manifestation[m.key] = m.score;
      });
      this.axios({
        url: `${portalUrl}swam/r/update`,
        headers: {
          token: this.$route.query.token,
        },
        data: {
          test_id: this.$route.query.test_id,
          manifestation,
          status: 'Close',
        },
        method: 'POST',
      }).then((res) => {
        this.loading = false;
        if (res.data.success) {
          this.scored = true;
        }
      });
    },
  },
};
</script>

<style scoped>
.sections-container {
  width: 100vw;
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: 10px;
  box-sizing: border-box;
  background-color: white;
}

.ac-text {
  margin-left: 15%;
}

.word-text {
  font-size: 18px;
  font-weight: bold;
}

.section {
  margin-bottom: 10px;
}

p {
  margin: 0;
  padding: 5px;
}

.select-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 25px;
}

.select-row > label {
  width: 60px;
  color: #333;
  font-size: 14px;
  font-weight: bold;
}

.select-row > select {
  height: 40px;
  width: 60vw;
  margin-left: 10px;
  border-radius: 10px;
  color: #333;
  font-size: 16px;
  font-weight: bold;
}

.submit-button {
  width: 50vw;
  height: 45px;
  border-radius: 22.5px;
  margin-top: 100px;
  background-color: cadetblue;
  color: white;
  font-size: 16px;
  font-weight: bold;
  border: none;
}
</style>
